import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeColorService {
    private ensureTag(): HTMLMetaElement {
        let tag = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement | null;
        if (!tag) {
            tag = document.createElement('meta');
            tag.setAttribute('name', 'theme-color');
            document.head.appendChild(tag);
        }
        return tag;
    }

    set(color: string) {
        this.ensureTag().setAttribute('content', color);
    }

    setAppleStatusBar(style: 'default' | 'black' | 'black-translucent' = 'black-translucent') {
        let tag = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]') as HTMLMetaElement | null;
        if (!tag) {
            tag = document.createElement('meta');
            tag.setAttribute('name', 'apple-mobile-web-app-status-bar-style');
            document.head.appendChild(tag);
        }
        tag.setAttribute('content', style);
    }
}
